import styles from "./LadderQuestion.module.css";
import { useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function LadderQuestion({ details = {}, value, onChange, name }) {
    const { t } = useTranslation();
    // Hardcoded step count and labels (based on translation keys)
    const min = 1;
    const max = 10;
    const bottomLabel = t("ladder.bottomLabel", { defaultValue: "Dół drabiny" });
    const topLabel = t("ladder.topLabel", { defaultValue: "Góra drabiny" });
    const selected = value?.choice ?? null;
    const detailsMap = value?.details || {};
    const text = detailsMap.text ?? "";
    const otherInputRef = useRef(null);

    const stepsDesc = useMemo(() => {
        const arr = [];
        for (let i = min; i <= max; i++) arr.push(i);
        return arr.reverse();
    }, []);

    const handleSelect = (val) => {
        onChange?.({ choice: val, details: { ...detailsMap, other: false, skip: false } });
    };

    const specialSelected = !!(detailsMap.other || detailsMap.skip);
    const otherChecked = !!detailsMap.other;
    const skipChecked = !!detailsMap.skip;
    const handleText = (e) => {
        const next = e.target.value;
        onChange?.({ choice: selected, details: { ...detailsMap, text: next } });
    };

    const toggleOther = () => {
        if (otherChecked) {
            onChange?.({ choice: null, details: { ...detailsMap, other: false } });
        } else {
            onChange?.({ choice: null, details: { ...detailsMap, other: true, skip: false } });
            // Focus the text field shortly after enabling it
            setTimeout(() => otherInputRef.current?.focus(), 0);
        }
    };

    const toggleSkip = () => {
        if (skipChecked) {
            onChange?.({ choice: null, details: { ...detailsMap, skip: false } });
        } else {
            onChange?.({ choice: null, details: { ...detailsMap, skip: true, other: false } });
        }
    };

    return (
        <div className={styles.wrap}>
            <div className={styles.topLabel}>{topLabel}</div>
            <div className={`${styles.steps} ${specialSelected ? styles.disabled : ''}`} role="radiogroup" aria-orientation="vertical" aria-label={t("ladder.ariaLabel", { defaultValue: "Wybierz szczebel drabiny" })}>
                {stepsDesc.map((n) => {
                    const isActive = selected === n;
                    return (
                        <label key={n} className={`${styles.step} ${isActive ? styles.active : ""}`}>
                            <input
                                type="radio"
                                name={name}
                                className={styles.radio}
                                checked={isActive}
                                onChange={() => handleSelect(n)}
                                disabled={specialSelected}
                                aria-label={t("ladder.step", { defaultValue: "Szczebel {{n}}", n })}
                            />
                            <span className={styles.rung} aria-hidden />
                            <span className={styles.num} aria-hidden>{n}</span>
                        </label>
                    );
                })}
            </div>
            <div className={styles.bottomLabel}>{bottomLabel}</div>
            <div className={styles.extras} role="group" aria-label={t("ladder.extraOptions", { defaultValue: "Dodatkowe opcje" })}>
                <label className={styles.extra}>
                    <input
                        type="checkbox"
                        className={styles.checkbox}
                        checked={otherChecked}
                        onChange={toggleOther}
                    />
                    <span className={styles.extraLabel}>{t("ladder.otherAnswer", { defaultValue: "Inna odpowiedź" })}</span>
                    <input
                        ref={otherInputRef}
                        className={`${styles.text} ${styles.otherText}`}
                        type="text"
                        value={text}
                        onChange={handleText}
                        placeholder={otherChecked ? t('selectText.textPlaceholder', { defaultValue: 'Wpisz tekst' }) : ''}
                        aria-label={t('ladder.otherTextAria', { defaultValue: 'Wpisz inną odpowiedź' })}
                        disabled={!otherChecked}
                    />
                </label>
                <label className={styles.extra}>
                    <input
                        type="checkbox"
                        className={styles.checkbox}
                        checked={skipChecked}
                        onChange={toggleSkip}
                    />
                    <span className={styles.extraLabel}>{t("ladder.noAnswer")}</span>
                </label>
            </div>

        </div>
    );
}
